// Generated by CoffeeScript 2.7.0
var AVAIABLE_FIELDS_COMPONENTS, SerialNumberFieldable;

import FieldListMixin from 'trunks/vue/admin/components/fields/list/mixin.js';

import Count from './count.js';

import ConstText from './const_text.js';

import ProposeTime from './propose_time.js';

import Proposer from './proposer.js';

import FormFields from './form_fields.js';

import DateTime from './date_time.js';

import RadioButton from './radio_button.js';

import SerialNumberBaseModel from './field_model.js';

AVAIABLE_FIELDS_COMPONENTS = {
  'Number': Count,
  ConstText,
  ProposeTime,
  Proposer,
  FormFields,
  RadioButton,
  DateTime
};

export default SerialNumberFieldable = Vue.extend({
  mixins: [FieldListMixin],
  props: {
    formFields: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    _createTypeField: function(type = 'ProposeTime') {
      var settings;
      settings = this.fieldable.settings ? this.fieldable.settings : {
        rule: null
      };
      return SerialNumberBaseModel.new({
        title: '',
        settings: {
          ...settings,
          form_fields: this.formFields
        },
        type: type,
        _editing: true,
        _destroy: false,
        children: []
      }, this.fieldable);
    },
    _getComponent: function(field) {
      var type;
      type = field.type.demodulize();
      return AVAIABLE_FIELDS_COMPONENTS[type] || ProposeTime;
    }
  }
});
